import React from 'react'
import { Activity, RefreshCw, AlertCircle } from 'lucide-react'

const Header = ({ apiHealth, onRefreshHealth }) => {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Activity className="text-blue-500" size={32} />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                CLayer Nodes
              </h1>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {/* API Status */}
            <div className="flex items-center gap-2">
              <div className={`w-2 h-2 rounded-full ${apiHealth ? 'bg-green-500' : 'bg-red-500'}`} />
              <span className={`text-sm font-medium ${apiHealth ? 'text-green-600' : 'text-red-600'}`}>
                {apiHealth ? 'API Connected' : 'API Disconnected'}
              </span>
            </div>

            {/* Refresh button */}
            <button
              onClick={onRefreshHealth}
              className="btn btn-secondary flex items-center gap-2"
              title="Refresh API status"
            >
              <RefreshCw size={16} />
            </button>
          </div>
        </div>

        {/* Alert if API disconnected */}
        {!apiHealth && (
          <div className="mt-4 alert alert-error flex items-center gap-2">
            <AlertCircle size={20} />
            <div>
              <strong>API unavailable</strong>
              <p className="text-sm">
                Make sure the backend server is running on port 3000.
              </p>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header 